module.exports = __webpack_public_path__ + "media/Cafe.36685ec4.mp3";